"use strict";

exports.__esModule = true;
exports.default = suffixPropName;

var _upperFirst = require("./upper-first");

/**
 * Suffix can be a falsey value so nothing is appended to string.
 * (helps when looping over props & some shouldn't change)
 * Use data last parameters to allow for currying.
 * @param {string} suffix
 * @param {string} str
 */
function suffixPropName(suffix, str) {
  return str + (suffix ? (0, _upperFirst.default)(suffix) : '');
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/suffix-prop-name.js
// module id = 1266
// module chunks = 0